import { render, staticRenderFns } from "./Dispatched.vue?vue&type=template&id=1e9823ea"
import script from "./Dispatched.vue?vue&type=script&lang=js"
export * from "./Dispatched.vue?vue&type=script&lang=js"
import style0 from "./Dispatched.vue?vue&type=style&index=0&id=1e9823ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports